const DEFAULT_STATE = {
  rubrics: [],
  siteIds: [],
  dates: [],
  displayMode: "feed",
  selected: {},
};

export default {
  namespaced: true,
  state: {
    ...DEFAULT_STATE,
  },
  getters: {
    getRubrics: (state) => state.rubrics,
    getSiteIds: (state) => state.siteIds,
    getDates: (state) => state.dates,
    getDisplayMode: (state) => state.displayMode,
    getSelected: (state) => Object.values(state.selected),
    getSelectedCount: (state) => Object.keys(state.selected).length,
    isSelected: (state) => (id) => Boolean(state.selected[id]),
  },
  mutations: {
    initState(state) {
      for (const [key, value] of Object.entries(DEFAULT_STATE)) {
        state[key] = Array.isArray(value) ? [...value] : value;
      }
      state.selected = {};
    },
    setRubrics(state, payload) {
      state.rubrics = payload;
    },
    setSiteIds(state, payload) {
      state.siteIds = payload;
    },
    setDates(state, payload) {
      state.dates = payload;
    },
    setDisplayMode(state, payload) {
      state.displayMode = payload;
    },
    setSelected(state, payload) {
      state.selected = payload;
    },
  },
  actions: {
    initState({ commit }) {
      commit("initState");
    },
    updateRubrics({ commit }, payload) {
      commit("setRubrics", payload);
    },
    updateSiteIds({ commit }, payload) {
      commit("setSiteIds", payload);
    },
    updateDates({ commit }, payload) {
      commit("setDates", payload);
    },
    updateDisplayMode({ commit }, payload) {
      commit("setDisplayMode", payload);
    },
    toggleSelect({ commit, state }, item) {
      const selected = { ...state.selected };
      if (selected[item.id]) {
        delete selected[item.id];
      } else {
        selected[item.id] = item;
      }
      commit("setSelected", selected);
    },
    clearSelection({ commit }) {
      commit("setSelected", {});
    },
  },
};
